export const EXTRACTED_TABLES_REQUEST = "EXTRACTED_TABLES_REQUEST";
export const EXTRACTED_TABLES_SUCCESS = "EXTRACTED_TABLES_SUCCESS";
export const EXTRACTED_TABLES_FAILURE = "EXTRACTED_TABLES_FAILURE";
